// extracted by mini-css-extract-plugin
export default {"controls":"EditBanner_controls__mWfOa","container":"EditBanner_container__igK5P"};